import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"liquid-container {{@class}}\" ...attributes {{this.setup}}>\n	{{~yield this~}}\n</div>")